module.exports = __webpack_public_path__ + "img/def-avatar.85c3d5be.png";